import { render, staticRenderFns } from "./MagazineProductMark.vue?vue&type=template&id=b313dc1e&scoped=true&"
import script from "./MagazineProductMark.vue?vue&type=script&lang=js&"
export * from "./MagazineProductMark.vue?vue&type=script&lang=js&"
import style0 from "./MagazineProductMark.vue?vue&type=style&index=0&id=b313dc1e&scoped=true&lang=css&"
import style1 from "./MagazineProductMark.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b313dc1e",
  null
  
)

export default component.exports